/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2021-03-04 14:54:15
 * @LastEditors: Please set LastEditors
 * @Description: 
 * @FilePath: \cloud_frontend\src\api\configurationlist.js
 * @
 */
import http from '@/axios/http'
import { getuser_id, getclient_user_id, getgroup } from "@/localStorage/localStorage";

//获取分组列表
export function getGroupList() {
    const data = {
        "user_id": getuser_id(),
        "offset": 1,
        "limit": 99999
    }
    return http({
        url: '/api/device/getGroupList',
        method: 'post',
        data
    })
}

//获取设备配置
export function listConfig(SN, did, mess) {
    const data = {
        SN: SN,
        did: did,
        mess: mess
    }
    return http({
        url: '/api/configListManager/listConfig',
        method: 'post',
        data
    })
}

//提交设备配置
export function updateConfig(SN, did, mess) {
    const data = {
        SN: SN,
        did: did,
        mess: mess
    }
    return http({
        url: '/api/configListManager/updateConfig',
        method: 'post',
        data
    })
}

//通过分组id获取分组下的设备
export function GroupDevices(gid, queryType, limit, offset, sn) {
    return http({
        url: '/api/device/group/devices',
        method: 'post',
        data: { gid, queryType, limit, offset, sn }
    })
}

//获取一二三级分组
export function getAddLevel3Group(pid) {
    return http({
        url: '/api/device/getAddLevelGroup',
        method: 'post',
        data: {
            pid,
        }
    })
}

// 分页获取分组
export function getGroupListPage(data) {
    return http({
        url: '/api/device/getAddLevelGroupPage',
        method: 'post',
        data
    })
}

// 获取网络接口基本信息
export function getNetworkInfo(did, sn, mess) {
    return http({
        url: '/api/device/networkInfo',
        method: 'post',
        data: {
            did,
            sn,
            mess,
        }
    })
}

// 智慧物联日志下载
export function getLog(data) {
    return http({
        url: '/api/log/iot',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

// 获取设备终端列表
export function getDeviceTerminalList(data) {
    return http({
        url: '/api/configListManager/getCommonProgressStatus',
        method: 'post',
        data
    })
}

// 获取设备MQTT状态
export function getDeviceMqttStatus(did) {
    return http({
        url: '/api/clients/' + did + '/online',
        method: 'get',
    })
}